import request from "../utils/request"

export default {
    getTopCategory() {
        return request({
            url: `/category?ac=getTopCategory`,
            method: 'get'
        })
    },

    getChildrenCategory(categoryId) {
        return request({
            url: `/category?ac=getChildrenCategory`,
            method: 'get',
            params: { categoryId }
        })
    },

    getLotteryLatest(params) {
        const p = typeof params === 'object' ? params : { lotteryCode: params }
        return request({
            url: `/lottery?ac=latest`,
            method: 'get',
            params: p
        })
    },

    getLotteryHistory(params, limit) {
        const p = typeof params === 'object' ? { ...params } : { lotteryId: params }
        if (limit !== undefined) p.limit = limit
        return request({
            url: `/lottery?ac=history`,
            method: 'get',
            params: p
        })
    },

    /**
     * 功能：提交大底验证条件，由后端直接返回统计和每日图表数据。
     * 参数：data 彩种、日期、号码、位置及投注配置。
     */
    calculateLotteryValidation(data) {
        return request({
            url: `/lottery?ac=validationSummary`,
            method: 'post',
            data
        })
    },

    /**
     * 功能：获取启用彩种的基础选项，不读取最新期开奖信息。
     * 参数：无。
     */
    getEnabledLotteryList() {
        return request({
            url: `/lottery?ac=enabledList`,
            method: 'get'
        })
    },

    /**
     * 功能：获取预测模块已启用的彩种基础选项。
     * 参数：无。
     */
    getPredictEnabledLotteryList() {
        return request({
            url: `/lottery?ac=predictEnabledList`,
            method: 'get'
        })
    },

    getLotteryListWithLatest() {
        return request({
            url: `/lottery?ac=listWithLatest`,
            method: 'get'
        })
    },

    getLotteryDrawRuleConfig(lotteryId) {
        return request({
            url: `/lottery?ac=drawRuleConfig`,
            method: 'get',
            params: { lotteryId }
        })
    },

    getLotteryPlayList(params) {
        return request({
            url: `/lotteryPlay?ac=list`,
            method: 'get',
            params
        })
    }
}
